import React,{useState} from "react";
import logoschool from "../../assets/images/logosignup.png";
import { useLocation, useNavigate } from "react-router-dom";
import EmailValidator from "email-validator";
import axios from "axios";
import { toast } from "react-toastify";
const ResetPass =()=>{
    const location = useLocation();
    const email = location.state?.email;
    const navigate = useNavigate();
  
    const [errorMsg, setErrorMsg] = useState("");
    const [error, setError] = useState(false);

    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sping, setSping] = useState(false);
  
    const conTinue = async () => {
        if (sping) return; // 🛑 Prevent multiple calls

      setSping(true)
        const baseURL = process.env.REACT_APP_BASE_URL;
        const isvalidEmail = EmailValidator.validate(email?.trim());
        if (email?.trim() === "" || isvalidEmail === false) {
          setError(true);
        }else{
          setError(false);
        }
        if (email?.trim() !== "" && isvalidEmail) {
          try {
            setLoading(true)
            const response = await axios.post(`${baseURL}/user/forgetEmailPassword`, {
              email: email.toLowerCase(),
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            });
            // if (response.data?.code !== 400) {
            // //   navigate("/", { state: { email } });
            // } else {
            //   alert("Email does not exist.");
            // }
            if (response.data?.code == 200) {
              toast.success(response.data?.message)
              setSping(false)
              //   navigate("/", { state: { email } });
              } else {
                toast.error(response.data?.message)
               setSping(false)

                // alert("Email does not exist.");
              }
  

            setLoading(false)
          } catch (error) {
            setLoading(false)
            setSping(false)

            // console.error('Error creating user:', error.response ? error.response.data : error.message);
          }
    
        }
      }
    




    return(<>
    
    <div className="school-pages-inner">
        <div className="school-content-page">
        {/* <img src={logoschool}/>  */}
          <img
          src={logoschool}
          alt="School Logo"
          style={{  cursor: "pointer" }}
          onClick={() => navigate("/school")}
        />
        <div className="schoo-outer">
            <div className="school-outer-pages forget-passw">
            <h2>Reset Password</h2>

            <p className="verification-code">Click “Continue” to reset your password for {email}</p>
                {/* aryangoswamiXYZ@gmail.com</p> */}

            <button className="continue-btn"
            onClick={conTinue}
            //  onClick={()=>navigate("/forgetpassword")}
             >{sping?"CONTINUING...":"CONTINUE"}</button>
            <p className="login-account" onClick={() => navigate("/login-page")} style={{ cursor: "pointer" }}>
  Back to Login
</p>

            <p className="term-part" >
	  <a href="#" >Terms of Use</a>  |  <a href="#" >Privacy Policy</a>
	</p>
            </div>

        </div>

        </div>

    </div>

    
    
    </>);

}
export default ResetPass;